import React from 'react';
import Chart from "react-google-charts";
import './timeline.styles.scss';
import dateFormat from 'dateformat';
import Loader from 'react-loader-spinner';
class Timeline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmedData: null,
      deathData: null,
      recData: null,
      isLoaded: false
    }
  }

  intervalID = null;

  async loadData(code) {
    try {
      let url = 'https://corona.lmao.ninja/v2/historical/all?lastdays=90';

      if (this.props.param) {
        url = `https://corona.lmao.ninja/v2/historical/${this.props.param}?lastdays=90`;
      }

      const res = await fetch(url);
      let data = await res.json();

      if (this.props.param) {
        this.setState({
          confirmedData: data.timeline.cases,
          deathData: data.timeline.deaths,
          recData: data.timeline.recovered,
          isLoaded: true
        });
      } else {
        this.setState({
          confirmedData: data.cases,
          deathData: data.deaths,
          recData: data.recovered,
          isLoaded: true
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  render() {
    let cTimeline = <Loader
      className="loader"
      type="Circles"
      color="#00BFFF"
      height={100}
      width={100}
    />;//<span>Loading</span>
    let dTimeline = <Loader
      className="loader"
      type="Circles"
      color="#00BFFF"
      height={100}
      width={100}
    />;
    if (this.state.isLoaded) {
      const confData = [];
      const d = { ...this.state.confirmedData };
      const dData = [];
      const dd = { ...this.state.deathData };
      const rd = { ...this.state.recData };
      for (const property in d) {
        confData.push([dateFormat(new Date(property), 'm/d/yy'), (d[property]), '#3f7fff', dd[property], '#ff0000', rd[property], '#4caf50']);
      }
      console.log(confData);
      for (const property in dd) {
        dData.push([dateFormat(new Date(property), 'm/d/yy'), dd[property], '#ff0000']);
      }
      // const maxLimit = dData[dData.length - 1][1];

      cTimeline = (
        <Chart
          className="graph"
          chartType="LineChart"
          data={[
            [
              'Day',
              'CONFIRMED',
              { role: 'style' },
              'DEATHS',
              { role: 'style' },
              'RECOVERED',
              { role: 'style' }
            ],
            ...confData
          ]}
          options={{
            title: 'Spread over time',
            curveType: 'function',
            legend: { position: 'bottom' },
            chartArea: { width: '75%' },
            lineWidth: 3,
            animation: {
              duration: 2000,
              easing: 'out',
              startup: true,
            },
            vAxis: {
              format: 'short',
            },
            series: {
              0: {
                color: '#3f7fff', visibleInLegend: true
              },
              1: {
                color: '#ff0000', visibleInLegend: true
              },
              2: {
                color: '#4caf50', visibleInLegend: true
              }
            }
          }}
        />
      );

      dTimeline = (
        <Chart
          className="graph"
          chartType="LineChart"
          data={[
            [
              'Day',
              'CONFIRMED',
              { role: 'style' },
              'DEATHS',
              { role: 'style' },
              'RECOVERED',
              { role: 'style' }
            ],
            ...confData
          ]}
          options={{
            title: 'Spread over time',
            curveType: 'function',
            legend: { position: 'bottom' },
            chartArea: { width: '75%' },
            lineWidth: 3,
            animation: {
              duration: 2000,
              easing: 'out',
              startup: true,
            },
            vAxis: {
              format: 'short',
              scaleType: 'log'
            },
            series: {
              0: {
                color: '#3f7fff', visibleInLegend: true
              },
              1: {
                color: '#ff0000', visibleInLegend: true
              },
              2: {
                color: '#4caf50', visibleInLegend: true
              }
            }
          }}
        />
      );
    }
    return (
      <div className="timeline">
        <div className="cases--confirmed">
          <h2>Linear</h2>
          {cTimeline}
        </div>
        <div className="cases--deaths">
          <h2>Logarithmic</h2>
          {dTimeline}
        </div>

      </div>
    );
  }
}

export default Timeline;